import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  onReload: () => void;
}

export function ChunkErrorScreen({ onReload }: Props) {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-background px-4 sm:px-6">
      <div className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-2xl border bg-card p-6 sm:p-8 md:p-10 text-center shadow-sm">
        <div className="mx-auto mb-5 sm:mb-6 flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-muted">
          <RefreshCw className="h-6 w-6 sm:h-7 sm:w-7 text-muted-foreground" />
        </div>
        <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold text-foreground">
          This page is out of date
        </h1>
        <p className="mt-2 sm:mt-3 text-sm sm:text-base text-muted-foreground">
          I've updated the app. Reload to get the latest version.
        </p>
        <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-3 sm:justify-center">
          <Button onClick={onReload} className="w-full sm:w-auto">
            Reload app
          </Button>
          <Button
            variant="outline"
            onClick={() => {
              window.location.href = "/";
            }}
            className="w-full sm:w-auto"
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
}
